export namespace LandingActions {
	export class GetHotJobList {
		static readonly type = '[Job Landing page] Get Hot Job List';
		constructor(public payload: any) {}
	}

	export class GetTopCategory {
		static readonly type = '[Job Landing page] Get Top Category';
		constructor() {}
	}
}
